import React, { Suspense, lazy } from 'react';
import { Hero } from './components/Hero';
// La barra de compra móvil se importa de forma directa (no lazy) para que esté
// disponible desde el primer scroll también en la versión publicada.
import { StickyBuyBar } from './components/StickyBuyBar';

/**
 * Everything below the first viewport is code-split so the Hero (LCP) ships
 * with the smallest possible JS payload. Each block reserves vertical space
 * while its chunk loads, which keeps CLS at zero.
 *
 * Recorrido: hero → dolor/solución → los 6 tomos → cómo son las recetas →
 * vista interior → para quién es → los 4 bonos → oferta → FAQ → cierre.
 */
const TransformationSection = lazy(() => import('./components/TransformationSection').then(m => ({
  default: m.TransformationSection
})));
const TomosSection = lazy(() => import('./components/TomosSection').then(m => ({
  default: m.TomosSection
})));
const PositioningSection = lazy(() => import('./components/PositioningSection').then(m => ({
  default: m.PositioningSection
})));
const InteriorSection = lazy(() => import('./components/InteriorSection').then(m => ({
  default: m.InteriorSection
})));
const AudienceSection = lazy(() => import('./components/AudienceSection').then(m => ({
  default: m.AudienceSection
})));
const BonosSection = lazy(() => import('./components/BonosSection').then(m => ({
  default: m.BonosSection
})));
const OfferSection = lazy(() => import('./components/OfferSection').then(m => ({
  default: m.OfferSection
})));
const FaqSection = lazy(() => import('./components/FaqSection').then(m => ({
  default: m.FaqSection
})));
const FinalCta = lazy(() => import('./components/FinalCta').then(m => ({
  default: m.FinalCta
})));
const Footer = lazy(() => import('./components/Footer').then(m => ({
  default: m.Footer
})));
interface DeferredProps {
  children: React.ReactNode;
  minHeight: string;
  background?: string;
}
function Deferred({
  children,
  minHeight,
  background = 'bg-cream'
}: DeferredProps) {
  return <Suspense fallback={<div className={`w-full ${background}`} style={{
    minHeight
  }} aria-hidden data-id="element-1" data-mp="356wji4cy4fe" />} data-id="element-0" data-mp="35ovimiemwr0">
      {children}
    </Suspense>;
}
export function App() {
  return <main className="w-full bg-cream text-charcoal" data-id="element-2" data-mp="d4e57s05daw6">
      <Hero data-id="element-3" data-mp="d3wdn8ofjkul" />
      <Deferred minHeight="560px" background="bg-white" data-id="element-4" data-mp="d2l7j27ii10b">
        <TransformationSection data-id="element-5" data-mp="86mh792mi8x9" />
      </Deferred>
      <Deferred minHeight="760px" background="bg-charcoal" data-id="element-6" data-mp="83qi3hf1he78">
        <TomosSection data-id="element-7" data-mp="3gm65ruscn35z" />
      </Deferred>
      <Deferred minHeight="660px" background="bg-sand" data-id="element-8" data-mp="3gj1vqgs7dd7e">
        <PositioningSection data-id="element-9" data-mp="3bnmerfywf16r" />
      </Deferred>
      <Deferred minHeight="820px" background="bg-white" data-id="element-10" data-mp="3qb7hv9vrx0eo">
        <InteriorSection data-id="element-11" data-mp="3qcr0v88tdpk5" />
      </Deferred>
      <Deferred minHeight="560px" data-id="element-12" data-mp="3lkhf84eqfbno">
        <AudienceSection data-id="element-13" data-mp="3ljg27ue5of3b" />
      </Deferred>
      <Deferred minHeight="620px" background="bg-white" data-id="element-14" data-mp="3liefgsns245r">
        <BonosSection data-id="element-15" data-mp="2xtv8cgggrxf9" />
      </Deferred>
      <Deferred minHeight="880px" background="bg-sand" data-id="element-16" data-mp="2xssf41vo5iw6">
        <OfferSection data-id="element-17" data-mp="2suqzxs1d63pz" />
      </Deferred>
      <Deferred minHeight="640px" data-id="element-18" data-mp="2stplddl52z3i">
        <FaqSection data-id="element-19" data-mp="18d9eyc0rhuut" />
      </Deferred>
      <Deferred minHeight="620px" background="bg-white" data-id="element-20" data-mp="18c6ou6b9jwfy">
        <FinalCta data-id="element-21" data-mp="1d4zsequzwyqg" />
      </Deferred>
      <Deferred minHeight="300px" background="bg-sand" data-id="element-22" data-mp="1d59h8b4b0zuk">
        <Footer data-id="element-23" data-mp="yfvalas44wiv" />
      </Deferred>
      <StickyBuyBar data-id="element-24" data-mp="ygwl9e57vh02" />
    </main>;
}